<template>
  <div class="management-agent-box">
    <div class="content-box">
      <!-- 搜索栏 -->
      <div class="content_title data_screen">
        <div class="data_screen_line">
          <span class="title" slot="reference" @click="clickCancel"
            >用户管理 > 用户详情</span
          >
        </div>
      </div>
      <!-- 具体内容 -->

      <div class="content_auto">
        <div class="content content_user">
          <div class="pic">
            <el-image :src="userData.picture" @error="loadPicError"></el-image>
          </div>
          <div class="userInfo">
            <el-form :model="userData" ref="addForm">
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="用户昵称："
                    :label-width="labelWidth"
                    style="margin-bottom: 0px"
                    >{{ userData.nickName }}</el-form-item
                  >
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="绑定设备A："
                    :label-width="labelWidth"
                    style="margin-bottom: 0px"
                    >{{ userData.deviceAMac }}
                  </el-form-item></el-col
                >
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="手机号码："
                    :label-width="labelWidth"
                    style="margin-bottom: 0px"
                    >{{ userData.phone }}</el-form-item
                  ></el-col
                >
                <el-col :span="12">
                  <el-form-item
                    label="绑定设备B："
                    :label-width="labelWidth"
                    style="margin-bottom: 0px"
                    >{{ userData.deviceBMac }}
                  </el-form-item></el-col
                >
              </el-row>

              <el-row>
                <el-form-item
                  label="最近登录："
                  :label-width="labelWidth"
                  style="margin-bottom: 0px"
                  >{{ userData.loginTime }}
                </el-form-item>
              </el-row>
            </el-form>
          </div>
        </div>
        <el-row :gutter="18">
        <!-- 健康档案 -->
        <el-col :span="10">
          <div class="content table_data" style="padding-bottom: 10px">
            <div>
              <span class="title">健康档案</span>
            </div>
            <!-- 表格 -->
            <div class="archiveDiv" style="width: 100%">
              <el-form :model="userData" ref="addForm">
                <el-row>
                  <!-- 左边 -->
                  <el-col :span="12">
                    <div class="archiveName">基础信息</div>
                    <div class="archiveView">
                      <el-form-item
                        label="用户姓名："
                        :label-width="archiveLabelWidth"
                        style="margin-bottom: 0px"
                        >{{ archiveData.userName }}</el-form-item
                      >
                      <el-form-item
                        label="生日："
                        :label-width="archiveLabelWidth"
                        style="margin-bottom: 0px"
                        >{{ archiveData.birthday }}</el-form-item
                      >
                      <el-form-item
                        label="身高(cm)："
                        :label-width="archiveLabelWidth"
                        style="margin-bottom: 0px"
                        >{{ archiveData.height }}</el-form-item
                      >
                      <el-form-item
                        label="体重(kg)："
                        :label-width="archiveLabelWidth"
                        style="margin-bottom: 0px"
                        >{{ archiveData.weight }}</el-form-item
                      >
                    </div>

                    <div class="archiveName">健康历程</div>
                    <div class="archiveView">
                      <el-form-item
                        label="是否已绝经："
                        :label-width="archiveLabelWidth"
                        style="margin-bottom: 0px"
                        >{{ archiveData.menopause==1?'是':'否'}}</el-form-item
                      >
                      <el-form-item
                        label="是否曾经有过病症："
                        :label-width="archiveLabelWidth"
                        style="margin-bottom: 0px"
                        >{{ archiveData.symptoms==1?'是':'否' }}</el-form-item
                      >
                      <el-form-item
                        label="是否有过手术史："
                        :label-width="archiveLabelWidth"
                        style="margin-bottom: 0px"
                        >{{ archiveData.historyOfSurgery==1?'是':'否' }}</el-form-item
                      >
                      <el-form-item
                        label="是否有过盆底病症家庭史："
                        style="margin-bottom: 0px"
                        >{{ archiveData.familyHistoryOfIllness==1?'是':'否' }}</el-form-item
                      >
                    </div>

                    
                  </el-col>
                  <!-- 右边 -->
                  <el-col :span="12">
                    <div class="archiveName">孕产经历</div>
                    <div class="archiveView">
                      <el-form-item
                        label="分娩次数："
                        :label-width="archiveLabelWidth"
                        style="margin-bottom: 0px"
                        >{{ archiveData.numberOfChildbirths }}</el-form-item
                      >
                      <el-form-item
                        label="最近分娩日期："
                        :label-width="archiveLabelWidth"
                        style="margin-bottom: 0px"
                        >{{ archiveData.latestDeliveryDate }}</el-form-item
                      >
                      <el-form-item
                        label="流产次数："
                        :label-width="archiveLabelWidth"
                        style="margin-bottom: 0px"
                        >{{ archiveData.numberOfMiscarriages }}</el-form-item
                      >
                    </div>
                    <div class="archiveName">当前困扰</div>
                    <div class="archiveView">
                      <el-form-item
                        label="是否漏尿："
                        :label-width="archiveLabelWidth"
                        style="margin-bottom: 0px"
                        >{{ archiveData.urinaryLeakage==1?'是':'否' }}</el-form-item
                      >
                      <el-form-item
                        label="是否有器官脱垂："
                        :label-width="archiveLabelWidth"
                        style="margin-bottom: 0px"
                        >{{ archiveData.organProlapse==1?'是':'否' }}</el-form-item
                      >
                      <el-form-item
                        label="是否阴道松弛"
                        :label-width="archiveLabelWidth"
                        style="margin-bottom: 0px"
                        >{{ archiveData.vaginalLaxity==1?'是':'否' }}</el-form-item
                      >
                      <el-form-item
                        label="是否盆底疼痛："
                        :label-width="archiveLabelWidth"
                        style="margin-bottom: 0px"
                        >{{ archiveData.pelvicPain==1?'是':'否' }}</el-form-item
                      >
                    </div>
                  </el-col>
                </el-row>
                <!-- 尾 -->
                <el-row >
                  <div class="archiveView" style="height:106px">
                  <el-form-item
                    label="是否存在其他症状："
                    :label-width="archiveLabelWidth"
                    style="margin-bottom: 0px"
                    >{{ archiveData.otherSymptoms==1?'是':'否' }}</el-form-item
                  >
                  <el-form-item
                    label="其他症状描述："
                    :label-width="archiveLabelWidth"
                    style="margin-bottom: 0px"
                    >{{ archiveData.otherSymptomsDesc }}</el-form-item
                  >
                    </div>
                </el-row>
              </el-form>
            </div>
          </div>
        </el-col>
        <!-- 使用日志 -->
        <el-col :span="14">
          <div class="content table_data">
            <div>
              <span class="title">使用日志</span>
            </div>
            <!-- 表格 -->
            <el-table :data="login_data" style="width: 100%">
              <el-table-column
                prop="createTime"
                label="使用时间"
                align="center"
                width="150"
              ></el-table-column>
              <el-table-column prop="type" label="操作类型" align="center" min-width="110">
                <template slot-scope="scope">
                  <span v-if="scope.row.type == 1">盆底康复训练</span>
                  <span v-if="scope.row.type == 2">私密抗衰训练</span>
                  <span v-if="scope.row.type == 3">盆底康复评估</span>
                  <span v-if="scope.row.type == 4">私密抗衰评估</span>
                </template>
              </el-table-column>
              <el-table-column prop="useType" label="使用模式" align="center" min-width="120">
                <template slot-scope="scope">
                  <span v-if="scope.row.useType == 0">P1</span>
                  <span v-if="scope.row.useType == 1">P2</span>
                  <span v-if="scope.row.useType == 2">P3</span>
                  <span v-if="scope.row.useType == 3">P4</span>
                  <span v-if="scope.row.useType == 4">P5</span>
                  <span v-if="scope.row.useType == 5">P6</span>
                  <span v-if="scope.row.useType == 6">P7</span>
                  <span v-if="scope.row.useType == 7">P8</span>
                  <span v-if="scope.row.useType == 8">P9</span>
                  <span v-if="scope.row.useType == 9">P</span>
                  <span v-if="scope.row.useType == 10">腹直肌康复</span>
                  <span v-if="scope.row.useType == 11">产后腰背痛</span>
                  <span v-if="scope.row.useType == 12">经期阵痛</span>
                  <span v-if="scope.row.useType == 13">压力性尿失禁</span>
                  <span v-if="scope.row.useType == 14">轻度肌肉松弛</span>
                  <span v-if="scope.row.useType == 15">重度肌肉松弛</span>
                  <span v-if="scope.row.useType == 16">轻度器官脱垂弛</span>
                  <span v-if="scope.row.useType == 17">中度器官脱垂弛</span>
                  <span v-if="scope.row.useType == 18">缓解盆底疼痛</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="useTime"
                label="使用时长(分钟)"
                align="center"
                width="120"
              >
                <template slot-scope="scope">
                  <span>{{ (scope.row.useTime / 60).toFixed(2) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="score"
                label="评估得分"
                align="center"
                width="80"
              ></el-table-column>
              <el-table-column
                prop="remark"
                label="评语"
                align="center"
                width="260"
              ></el-table-column>
            </el-table>
            <!-- 表格结束 -->
            <!-- 分页 -->
            <div class="page">
              <el-pagination
                background
                layout="total,prev, pager, next"
                :total="login_page.total"
                :page-size="login_page.size"
                @current-change="pageChangeByLogin"
              ></el-pagination>
            </div>
          </div>
        </el-col>

        </el-row>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  data() {
    return {
      // 名称
      title: "用户详情",
      user: null,
      labelWidth: "100px",
      archiveLabelWidth: "150px",
      dialogVisible: false,
      form: {
        id: null,
        mac: null,
        userPhone: null,
      },
      // 校验规则
      rules: {
        operationPwd: [
          { required: true, message: "请输入操作密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "密码在 6 到 20 个之间",
            trigger: "blur",
          },
        ],
        userPhone: [
          {
            required: true,
            message: "请输入绑定用户的手机号码",
            trigger: "blur",
          },
          {
            min: 11,
            max: 11,
            message: "手机号码为11位",
            trigger: "blur",
          },
        ],
      },
      user: null, // 登录用户
      userData: {
        nickName: "东方不败",
        phone: "13256345623",
        sex: 1,
      },
      login_page: {
        total: 3,
        size: 10,
        currPage: 1,
      },
      login_data: [
        {
          id: 1,
          loginTime: "2021-01-01 12:03:05",
          phoneType: "HUAWEI",
          phoneClass: "P30",
          phoneSystem: "安卓10",
        },
        {
          id: 2,
          loginTime: "2021-01-01 12:03:05",
          phoneType: "HUAWEI",
          phoneClass: "P30",
          phoneSystem: "安卓10",
        },
        {
          id: 3,
          loginTime: "2021-01-01 12:03:05",
          phoneType: "HUAWEI",
          phoneClass: "P30",
          phoneSystem: "安卓10",
        },
      ],
      archiveData: [],
      // return 结束
    };
  },
  updated() {},
  created() {
    // 加载数据
    let edit = JSON.parse(sessionStorage.getItem("dataInfo"));
    if (edit) {
      if (edit.type != "userInfo") {
        window.history.back();
        return;
      }
      this.userData = edit.data;
      console.log("host:", this.$axios.defaults.baseURL);
      // 组装头像路径
      this.userData.pic = this.$axios.defaults.baseURL + "" + edit.data.pic;
      this.queryUserLogins();
      this.queryArchiveInfo();

      this.user = JSON.parse(sessionStorage.getItem("user"));
      console.log("登录用户", this.user);
    } else {
      // 没有查询数据，返回上一页
      window.history.back();
    }
  },
  methods: {
    // 头像加载失败
    loadPicError() {
      console.log("加载了");
      this.userData.pic = "../../../../static/images/logo.png";
    },
    clickDelete(row) {
      this.form.id = row.id;
      this.form.mac = row.mac;
      this.form.operationPwd = null;
      this.form.userPhone = null;
      this.dialogVisible = true;
    },
    submitDelete(ref) {
      var that = this;
      // 表单校验
      this.$refs[ref].validate((valid) => {
        // 校验结果
        if (!valid) {
          // 校验不通过
          return;
        }
        // 添加逻辑处理
        const url = "/web/binding/unbind";
        that.$axios
          .post(url, {
            id: that.form.id,
            operationPwd: that.form.operationPwd,
            userPhone: that.form.userPhone,
          })
          .then((res) => {
            if (res.data.code == 1000) {
              that.$message.success("操作成功");
              that.lock_page.currPage = 1;
              that.dialogVisible = false;
              that.queryDoorLocks();
            } else if (res.data.code == 2001) {
              that.$message.error("登录失效，请重新登录");
              that.$router.push({ path: "/login" });
            } else if (res.data.code == 2002) {
              that.$message.error("没有操作权限");
              that.dialogVisible = false;
            } else if (res.data.code == 4041) {
              that.$message.error("未设置操作密码，请先设置！");
              that.dialogVisible = false;
            } else {
              that.$message.error(res.data.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    clickOpenLock(row) {
      var data = {
        type: "openLockLog",
        add: false,
        data: {
          deviceId: row.deviceId,
          bindId: row.id,
        },
      };
      sessionStorage.setItem("dataInfo", JSON.stringify(data));
      this.$router.push({ path: "/open/lock/log" });
    },
    // 点击了取消
    clickCancel() {
      sessionStorage.setItem("dataInfo", null);
      this.$router.push({ path: "/user" });
    },
    pageChangeByDoorLock(res) {
      this.lock_page.currPage = res;
      this.queryDoorLocks();
    },
    queryArchiveInfo() {
      let that = this;
      const url = "/api/web/user/queryArchiveInfoById";
      that.door_lock_data = [];
      this.$axios
        .post(url, {
            id: this.userData.id,
        })
        .then((res) => {
          if (res.data.code == 1000) {
            this.archiveData = res.data.data
          } else if (res.data.code == 4030) {
          } else if (res.data.code == 2001) {
            that.$message.error("登录失效，请重新登录");
            that.$router.push({ path: "/login" });
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    pageChangeByLogin(res) {
      this.login_page.currPage = res;
      this.queryUserLogins();
    },
    // 查询数据
    queryUserLogins() {
      let that = this;
      const url = "/api/web/device/pageUsageRecordList";
      that.login_data = [];
      this.$axios
        .post(url, {
          page: this.login_page.currPage,
          size: this.login_page.size,
          param: {
            userId: this.userData.id,
          },
        })
        .then((res) => {
          if (res.data.code == 1000) {
            that.login_data = res.data.data.list;
            that.login_page.total = Number(res.data.data.totalItems);
          } else if (res.data.code == 4030) {
          } else if (res.data.code == 2001) {
            that.$message.error("登录失效，请重新登录");
            that.$router.push({ path: "/login" });
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // methods 结束
  },
};
</script>

<style scoped>
/* 外盒子 */
.management-agent-box {
  height: 100%;
  width: 100%;
  padding: 15px;
  background: #f8fafb;
}
/* 内盒子 */
.content-box {
  width: 100%;
  height: 100%;
}
/* 内容盒子 */
.content_title {
  width: 100%;
  background: #ffffff;
  padding-left: 30px;
  padding-right: 30px;
  /*padding-top: 10px;*/
  border-radius: 5px;
}

/* 内容盒子 
.content {
  width: 100%;
  height: calc(100% - 90px);
 
  background: #ffffff;
  padding-left: 30px;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 5px;
}*/
.content_auto {
  /*height: 100%;*/
  height: calc(100% - 110px);
  overflow-y: auto;
}
/* 内容 */
.content {
  background-color: #fff;
  margin-top: 15px;
  /*margin-left: 15px;*/
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 30px;
  padding-right: 30px;
  border-radius: 5px;
}
/* 滚动条样式 */
.content_auto::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.content_auto::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #00cb9f;
}
.content_auto::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(167, 163, 163, 0.2);
  border-radius: 10px;
  background: #ededed;
}
/* 搜索栏 */
.data_screen {
  height: 90px;
  /*margin-bottom: 15px;
  padding-top: 0px;*/

  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}
/* 搜索栏居中 */
.data_screen_line {
  line-height: 32px;
  width: 100%;

  display: flex;
  justify-content: start;
  align-items: flex-start;
}
/* 标题 */
.title {
  margin-right: 30px;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #454647;
  letter-spacing: 0;
  cursor: pointer;
  /* text-align: center; */
}
/* 用户基本信息 */
.content_user {
  padding-top: 25px;
  height: 180px;
}
/* 头像 */
.pic {
  width: 130px;
  height: 130px;
  overflow: hidden;
  float: left;
}
.pic div {
  width: 130px;
  height: 130px;
}
.userInfo {
  float: left;
  margin-left: 30px;
}
.table_data {
  padding-bottom: 70px;
}
.table_data_left {
  margin-right: 15px;
}
/* 分页 */
.page {
  /* position:absolute;
  bottom: 50px;
  right: 50px; */
  float: right;
  margin-top: 20px;
  margin-right: 20px;
}

.archiveDiv {
  width: 100%;
  margin-top: 10px;
}
.archiveName {
  text-indent: 30px;
}
.archiveView {
  border: 1px solid #aaa7a7;
  margin: 10px 20px;
  border-radius: 10px;
  padding: 10px;
  height: 182px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/user/userInfo.vue